<div class="profile-header">
  <div class="profile-img" [style.background-image]="userData.profile.avatar ? 'url(' + userData.profile?.avatar + ')' : ''"></div>
  <div class="team-info">
    <h3>{{userData.profile.name}}</h3>
    <p>{{userData.profile.league}} {{userData.profile.gender}} {{userData.profile.club.name}}</p>
  </div>
</div>

<form *ngIf="profileForm" class="profile-section mt-5" [formGroup]="profileForm">

  <div class="title-wrap">
    <h1>{{'PROFILE.TITLE' | translate}}</h1>
    <button class="btn edit-btn"
            (click)="toggleEdit(true, false)" *ngIf="!editProfileMode">
      {{'PROFILE.EDIT_BTN' | translate}}
    </button>
  </div>

  <div class="form-group with-icon with-loader mt-4">
    <label for="club">{{(studentCouncil ? 'PROFILE.SCHOOL.NAME' : 'PROFILE.TEAM.CLUB') | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-highlight"></i>
    <input id="club" name="club" type="text" formControlName="club" [readonly]="!editProfileMode"
           (input)="onClubSearch($event)" autocomplete="off"/>
    <span class="loader" *ngIf="loadingClubs"></span>
    <ul *ngIf="editProfileMode && clubOptions && clubOptions.length" class="suggestions-list club">
      <li *ngFor="let option of clubOptions" (click)="selectClubOption(option); $event.stopPropagation()">
        <div class="team">
          <p class="name">{{ option.name }}</p>
        </div>
      </li>
    </ul>

    <div *ngIf="editProfileMode && profileForm.get('club')?.touched && profileForm.get('club')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="team-name">{{(studentCouncil ? 'PROFILE.SCHOOL.CLASS' : 'PROFILE.TEAM.TEAM_NAME') | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-highlight"></i>
    <input id="team-name" name="team-name" formControlName="teamName" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('name')?.touched && profileForm.get('name')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon with-loader mt-3">
    <label for="address">{{'PROFILE.ADDRESS' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-map-pin"></i>
    <input id="address" name="address" type="text" [readonly]="!editProfileMode"
           formControlName="address" (input)="onAddressSearch($event)"/>
    <span class="loader" *ngIf="loadingAddress"></span>
    <ul *ngIf="editProfileMode && addressSuggestions.length" class="suggestions-list">
      <li *ngFor="let suggestion of addressSuggestions"
          (click)="selectAddress(suggestion);">
        {{ suggestion.displayName }}
      </li>
    </ul>
    <div *ngIf="editProfileMode && profileForm.get('address')?.touched && profileForm.get('address')?.value && !selectedAddress">
      <p class="text-danger">{{'PROFILE.ADDRESS_ERROR' | translate}}</p>
    </div>
  </div>

  <div class="form-group with-icon mt-3" *ngIf="!studentCouncil">
    <label for="league">{{'PROFILE.LEAGUE' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-trophy"></i>
    <input id="league" name="league" formControlName="league" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('league')?.touched && profileForm.get('league')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="age-group">{{'PROFILE.AGE' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-shirt"></i>
    <input id="age-group" name="age-group" formControlName="ageGroup" class="form-control"
           placeholder="e.g. 12-14" [readonly]="!editProfileMode"
           mask="00-00" type="text"/>
    <div *ngIf="editProfileMode && profileForm.get('ageGroup')?.touched && profileForm.get('ageGroup')?.invalid">
      <small class="text-danger" *ngIf="profileForm.get('ageGroup')?.errors?.['required']">
        {{'PROFILE.FIELD_REQUIRED' | translate}}
      </small>
      <small class="text-danger" *ngIf="profileForm.get('ageGroup')?.errors?.['invalidFormat']">
        {{'PROFILE.INVALID_FORMAT' | translate}}
      </small>
      <small class="text-danger" *ngIf="profileForm.get('ageGroup')?.errors?.['invalidRange']">
        {{'PROFILE.INVALID_RANGE' | translate}}
      </small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="number-of-players">{{(studentCouncil ? 'PROFILE.SCHOOL.NUM_STUDENTS' : 'PROFILE.TEAM.NUM_PLAYERS') | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-users-group"></i>
    <input id="number-of-players" name="number-of-players" formControlName="numberOfPlayers" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('numberOfPlayers')?.touched && profileForm.get('numberOfPlayers')?.invalid">
      <small class="text-danger" *ngIf="profileForm.get('numberOfPlayers')?.errors?.['required']">
        {{'PROFILE.FIELD_REQUIRED' | translate}}
      </small>
      <small class="text-danger" *ngIf="profileForm.get('numberOfPlayers')?.errors?.['min']">
        {{'PROFILE.PLAYERS_ERROR' | translate}}
      </small>
    </div>
  </div>

  <div class="form-group with-icon mt-3" *ngIf="!studentCouncil">
    <label for="gender">{{'PROFILE.GENDER' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon icon-gender"></i>
    <input *ngIf="!editProfileMode" id="gender" number="gender" formControlName="gender" [readonly]="true" />
    <div class="custom-dropdown" *ngIf="editProfileMode">
      <select formControlName="gender" class="form-control">
        <option value="">{{'PROFILE.SELECT' | translate}}</option>
        <option value="male">{{'PROFILE.MALE' | translate}}</option>
        <option value="female">{{'PROFILE.FEMALE' | translate}}</option>
      </select>
    </div>
    <div *ngIf="editProfileMode && profileForm.get('gender')?.touched && profileForm.get('gender')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="manager-name">{{'PROFILE.MANAGER_NAME' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-id-badge"></i>
    <input id="manager-name" name="manager-name" formControlName="managerName" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('managerName')?.touched && profileForm.get('managerName')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="manager-address">{{'PROFILE.MANAGER_ADDRESS' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-map-pin"></i>
    <input id="manager-address" name="manager-address" formControlName="managerAddress" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('managerAddress')?.touched && profileForm.get('managerAddress')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="contact-person-name">{{'PROFILE.CONTACT_PERSON' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-user-circle"></i>
    <input id="contact-person-name" name="contact-person-name" formControlName="contactPersonName" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('contactPersonName')?.touched && profileForm.get('contactPersonName')?.invalid">
      <small class="text-danger">{{'PROFILE.FIELD_REQUIRED' | translate}}</small>
    </div>
  </div>

  <div class="form-group with-icon mt-3 phone-field">
    <label for="phone">{{'PROFILE.PHONE' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-c-phone" *ngIf="!editProfileMode"></i>

    <input
      *ngIf="!editProfileMode"
      class="form-control"
      id="phone"
      name="phone"
      type="text"
      [value]="getPhoneDisplayValue()"
      readonly
    />

    <ngx-intl-tel-input
      *ngIf="editProfileMode"
      [cssClass]="'form-control phone-control'"
      [enableAutoCountrySelect]="false"
      [enablePlaceholder]="isBrowser"
      [searchCountryFlag]="true"
      [searchCountryField]="searchCountryFields"
      [selectFirstCountry]="false"
      [preferredCountries]="preferredCountries"
      [onlyCountries]="onlyCountries"
      [phoneValidation]="true"
      [separateDialCode]="true"
      [maxLength]="15"
      [selectedCountryISO]="selectedCountryISO"
      (countryChange)="onPhoneCountryChange($event)"
      inputId="phone"
      formControlName="phone">
    </ngx-intl-tel-input>

    <div *ngIf="editProfileMode && ((profileForm.get('phone')?.touched && profileForm.get('phone')?.invalid) || (formError && formError.profile))">
      <small *ngIf="profileForm.get('phone')?.errors?.['required']" class="text-danger">
        {{'PROFILE.FIELD_REQUIRED' | translate}}
      </small>
      <small *ngIf="profileForm.get('phone')?.errors?.['validatePhoneNumber']" class="text-danger">
        {{'PROFILE.PHONE_ERROR' | translate}}
      </small>
      <small *ngIf="formError && formError.profile.phone_number" class="text-danger">
        {{formError.profile.phone_number[0]}} <!-- TODO -->
      </small>
    </div>
  </div>

  <div class="form-group with-icon mt-3">
    <label for="email">{{'PROFILE.EMAIL' | translate}} <span class="req" *ngIf="editProfileMode">*</span></label>
    <i class="icon custom-c-mail"></i>
    <input id="email" name="email" formControlName="email" [readonly]="!editProfileMode" />
    <div *ngIf="editProfileMode && profileForm.get('email')?.touched && profileForm.get('email')?.invalid || (formError && formError.email)">
      <small *ngIf="profileForm.get('email')?.errors?.['required']" class="text-danger">
        {{'PROFILE.FIELD_REQUIRED' | translate}}
      </small>
      <small *ngIf="profileForm.get('email')?.errors?.['email']" class="text-danger">
        {{'PROFILE.EMAIL_INVALID' | translate}}
      </small>
      <small *ngIf="formError && formError.email" class="text-danger">
        {{formError.email}}
      </small>
    </div>
  </div>

  <small *ngIf="editProfileMode && error" class="text-danger">
    {{errorMessage}}
  </small>

  <div *ngIf="editProfileMode">
    <p *ngFor="let key of objectKeys(formError || {})" class="mt-2 align-items-center">
      <small class="text-danger">
        {{ formError[key] }}
      </small>
    </p>
  </div>

  <div *ngIf="editProfileMode" class="action-buttons mt-4">
    <button class="btn btn-secondary" type="button"
            (click)="cancelEdit(true, false)">Cancel</button>
    <button class="btn btn-primary-henterpant with-loader" type="button"
            (click)="saveChanges(true, false)" [disabled]="!profileForm.valid">
      {{'PROFILE.SAVE_BUTTON' | translate}} <span class="loader" *ngIf="loadingProfile"></span>
    </button>
  </div>
</form>

<form class="security-section" [formGroup]="securityForm">
  <div class="title-wrap">
    <h2>{{'PROFILE.TITLE_PAS' | translate}}</h2>
    <button class="btn edit-btn" (click)="toggleEdit(false, true)" *ngIf="!editSecurityMode">Edit</button>
  </div>

  <div class="form-group pass mt-3">
    <label for="password">{{'PROFILE.PASSWORD' | translate}} <span class="req" *ngIf="editSecurityMode">*</span></label>
    <input id="password" name="password" class="form-control" [readonly]="!editSecurityMode"
           formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
    <i class="icon password-icon" *ngIf="editSecurityMode"
       [ngClass]="{'icon-eye': showPassword, 'icon-eye-closed': !showPassword}"
       (click)="togglePasswordVisibility('password')"></i>
    <div *ngIf="securityForm.get('password')?.touched && securityForm.get('password')?.invalid">
      <small *ngIf="securityForm.get('password')?.errors?.['required']" class="text-danger">
        {{'PROFILE.FIELD_REQUIRED' | translate}}
      </small>
      <small *ngIf="securityForm.get('password')?.errors?.['minlength']" class="text-danger">
        {{'PROFILE.PASSWORD_INVALID' | translate}}
      </small>
    </div>
  </div>

  <div class="form-group pass mt-3" *ngIf="editSecurityMode">
    <label for="confirmPassword">{{'PROFILE.CONFIRM_PASSWORD' | translate}} <span class="req">*</span></label>
    <input id="confirmPassword" name="confirmPassword" class="form-control"
           [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" />
    <i class="icon password-icon"
       [ngClass]="{'icon-eye': showConfirmPassword, 'icon-eye-closed': !showConfirmPassword}"
       (click)="togglePasswordVisibility('confirmPassword')"></i>
    <div *ngIf="securityForm.get('confirmPassword')?.touched && (securityForm.get('confirmPassword')?.invalid || securityForm.hasError('passwordsMismatch'))">
      <small *ngIf="securityForm.get('confirmPassword')?.errors?.['required']" class="text-danger">
        {{'PROFILE.FIELD_REQUIRED' | translate}}
      </small>
      <small *ngIf="securityForm.get('confirmPassword')?.errors?.['minlength']" class="text-danger">
        {{'PROFILE.CONFIRM_PASSWORD_INVALID' | translate}}
      </small>
      <small *ngIf="securityForm.hasError('passwordsMismatch')" class="text-danger">
        {{'PROFILE.CONFIRM_PASSWORD_ERROR' | translate}}
      </small>
    </div>
  </div>

  <small *ngIf="editSecurityMode && error" class="text-danger">
    {{errorMessage}}
  </small>

  <div *ngIf="editSecurityMode" class="action-buttons mt-4">
    <button type="button" (click)="cancelEdit(false, true)"
            class="btn btn-secondary">{{'PROFILE.CANCEL_BUTTON' | translate}}</button>
    <button type="button" (click)="saveChanges(false, true)" [disabled]="!securityForm.valid"
            class="btn btn-primary-henterpant">{{'PROFILE.SAVE_BUTTON' | translate}}</button>
  </div>
</form>
